require('../../modules/es6.number.min-safe-integer');
module.exports = -0x1fffffffffffff;



//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/core-js/library/fn/number/min-safe-integer.js
// module id = 643
// module chunks = 168707334958949